import ApplicationHeader from "@rio-cloud/rio-uikit/ApplicationHeader";
import SimpleTooltip from "@rio-cloud/rio-uikit/components/tooltip/SimpleTooltip";
import useOnlineStatus from "@rio-cloud/rio-uikit/useOnlineStatus";
import { DefaultUserMenu } from "@rio-cloud/rio-user-menu-component";
import IframeResizer from "iframe-resizer-react";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { config } from "../../config";
import {
	ALERTS_ROUTE,
	HEALTH,
	DEFAULT_ROUTE,
	DOWNTIME_ROUTE,
	NOTIFICATIONS_ROUTE,
	RECURRENCE_ROUTE,
	OLD_DASHBOARD,
} from "../../routes/Router";
import { LinkWithQuery } from "../../components/link/LinkWithQuery";
import ServiceInfo from "./ServiceInfo";
import { useAppDispatch, useAppSelector } from "../../configuration/setup/hooks";
import { getUserAccount } from "../../configuration/login/loginSlice";
import { setParamsFilter } from "../../stores/dashboard/dashboardPageSlice";
import { Switch } from "@rio-cloud/rio-uikit";

const STORAGE_KEY = "maila-ui-preference";
const AppHeader = () => {
	const environment = import.meta.env.PROD ? "production" : "local";
	const accountId = useAppSelector(getUserAccount);
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const controlTowerAccountId = "b1cbe9de-be81-4c67-9a8f-bdcbc782ab50";

	const isDashboardRoute = location.pathname === DEFAULT_ROUTE || location.pathname === OLD_DASHBOARD;

	const [isNewUi, setIsNewUi] = useState<boolean>(() => {
		const saved = localStorage.getItem(STORAGE_KEY);
		return saved === "true";
	});

	const dashboardRoute = isNewUi ? DEFAULT_ROUTE : OLD_DASHBOARD;

	const navItems = [
		{
			key: "dashboard",
			route: (
				<LinkWithQuery to={dashboardRoute}>
					<FormattedMessage id={"general.app.page.dashboard"} />
				</LinkWithQuery>
			),
		},
		/*{
			key: "vehicleHealth",
			route: (
				<LinkWithQuery to={HEALTH}>
					<FormattedMessage id={"general.app.page.health"} />
				</LinkWithQuery>
			),
		},*/
		{
			key: "alerts",
			route: (
				<LinkWithQuery to={ALERTS_ROUTE}>
					<FormattedMessage id={"general.app.page.alerts"} />
				</LinkWithQuery>
			),
		},
		{
			key: "notifications",
			route: (
				<LinkWithQuery to={NOTIFICATIONS_ROUTE}>
					<FormattedMessage id={"general.app.page.notifications"} />
				</LinkWithQuery>
			),
		},
		{
			key: "downtime",
			route: (
				<LinkWithQuery to={DOWNTIME_ROUTE}>
					<FormattedMessage id={"general.app.page.downtime"} />
				</LinkWithQuery>
			),
		},
		...(accountId !== controlTowerAccountId
			? [
					{
						key: "recurrence",
						route: (
							<LinkWithQuery to={RECURRENCE_ROUTE}>
								<FormattedMessage id={"general.app.page.recurrence"} />
							</LinkWithQuery>
						),
					},
				]
			: []),
	];

	const handleToggleChange = () => {
		const newValue = !isNewUi;
		setIsNewUi(newValue);
		localStorage.setItem(STORAGE_KEY, String(newValue));

		dispatch(setParamsFilter(newValue ? "" : "not_alerts"));

		const targetRoute = newValue ? DEFAULT_ROUTE : OLD_DASHBOARD;
		navigate(targetRoute + location.search);
	};

	useEffect(() => {
		if (isDashboardRoute) {
			const saved = localStorage.getItem(STORAGE_KEY);

			if (saved === null) {
				if (location.pathname === DEFAULT_ROUTE) {
					navigate(OLD_DASHBOARD + location.search, { replace: true });
				}
				return;
			}

			const isCurrentlyNewUi = location.pathname === DEFAULT_ROUTE;
			if (isCurrentlyNewUi !== isNewUi) {
				setIsNewUi(isCurrentlyNewUi);
				localStorage.setItem(STORAGE_KEY, String(isCurrentlyNewUi));
			}
		}
	}, [location.pathname, isDashboardRoute]);

	const isOnline = useOnlineStatus();
	const serviceInfoItem = <ServiceInfo />;
	const userMenuItem = <DefaultUserMenu environment={environment} />;
	const toggleSwitchUi = (
		<div className="display-flex align-items-center height-100pct">
			<Switch onChange={handleToggleChange} checked={isNewUi} enabledText="NEW UI" disabledText="OLD UI" />
		</div>
	);

	const isAppOnline = isOnline ? (
		<SimpleTooltip content={<FormattedMessage id={"general.app.online"} />} placement="bottom">
			<span className="text-success rioglyph rioglyph-ok-sign text-size-h3" />
		</SimpleTooltip>
	) : (
		<SimpleTooltip content={<FormattedMessage id={"general.app.offline"} />} placement="bottom">
			<span className="text-danger rioglyph rioglyph-remove-sign text-size-h3" />
		</SimpleTooltip>
	);

	return (
		<>
			<ApplicationHeader
				label={<FormattedMessage id="general.app.name" />}
				appNavigator={<IframeResizer className="iFrameResizer" src={config.backend.MENU_SERVICE} />}
				homeRoute={<Link to={config.homeRoute || ""} />}
				navItems={navItems}
				actionBarItems={[...(isDashboardRoute ? [toggleSwitchUi] : []), isAppOnline, serviceInfoItem, userMenuItem]}
			/>
		</>
	);
};

export default AppHeader;
